export type Platform = 'ios' | 'android' | 'web';

const isIOSUserAgent = (ua?: string) => {
  if (!ua) return false;
  return /iPad|iPhone|iPod/i.test(ua);
};

const isAndroidUserAgent = (ua?: string) => {
  if (!ua) return false;
  return /Android/i.test(ua);
};

// SSR-safe: no server, only use the passed userAgent.
// On client, fallback to navigator.userAgent.
export const getPlatform = (userAgent?: string): Platform => {
  if (typeof window === 'undefined') {
    if (isIOSUserAgent(userAgent)) return 'ios';
    if (isAndroidUserAgent(userAgent)) return 'android';
    return 'web';
  }

  const ua = navigator.userAgent;
  if (isIOSUserAgent(ua)) return 'ios';
  if (isAndroidUserAgent(ua)) return 'android';
  return 'web';
};
const isCapacitorIOS = () => {
  if (typeof window === 'undefined') return false

  const cap = (window as any).Capacitor
  return Boolean(cap && typeof cap.getPlatform === 'function' && cap.getPlatform() === 'ios')
}

export const isIOS = (userAgent?: string) => {
  // Se estiver no app (Capacitor), confia no Capacitor (isso NÃO afeta Safari)
  if (isCapacitorIOS()) return true

  // Fora do app (Safari/Chrome), nunca trate como iOS para não mudar o site
  return false
}
